import React from 'react';
import cl from './HomeInfo.module.css';
import { NavLink } from 'react-router-dom';

import buy from "../../../image/pngtree-buy-icon-design-png-image_1012861.jpg";
import about from "../../../image/depositphotos_37470025-stock-photo-about-us.jpg";

const HomeInfo = (props) => {
  return (
    <section className={cl.about}>
      {/* <NavLink className={cl.link_image} to='/news'>
            <img className={cl.big_image} src='https://img.freepik.com/fotos-gratis/conceito-de-simbolos-de-icones-de-comunicacao-de-tecnologia_53876-120314.jpg'/>
          </NavLink> */}
      <NavLink className={cl.link_image} to="/products">
        <img alt="buy" className={cl.big_image} src={buy} />
      </NavLink>
      <NavLink className={cl.link_image} to="/about">
        <img alt="about" className={cl.big_image} src={about} />
      </NavLink>
    </section>
  );
};

export default HomeInfo;
